// SUMMER15 promotion has ended — popup and price badge disabled.
(function () { 'use strict'; })();
